import * as clsx from 'clsx';
// this is needed to support jest's loading of the module using commonjs while esModuleInterop is enabled in quantum-product.
var exportFn = clsx.default || clsx;
export default exportFn;
